import script from "./TemplateReport.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateReport.vue?vue&type=script&setup=true&lang=js"

import "./TemplateReport.vue?vue&type=style&index=0&id=3a81c3b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a81c3b5"]])

export default __exports__